import { Col, Row } from "react-bootstrap";
import { EViewSolarEstimationSolarProductCategory } from "../../../../shared/oversight-core/enums/view-solar-estimation-solar-product-category";
import { IViewSolarEstimationSolarProduct } from "../../../../shared/oversight-core/interfaces/view-solar-estimation-solar-product";
import MaterialIcon from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import { formatWithCommas } from "../../../../shared/oversight-core/utils/format-with-commas";
import Helper from "../../../../shared/oversight-core/utils/helpers";
import { getSolarProductIcon } from "../../../../shared/oversight-core/utils/solar-product-icon";
import styles from "./approved-solar-component.module.scss";

interface IProps {
  product: IViewSolarEstimationSolarProduct;
  count: number;
}

const ApprovedSolarComponent = (props: IProps) => {
  const { product, count } = props;

  const { name, voltage, maxOperatingVoltage, price, currency, category } =
    product;

  return (
    <div
      className={`px-4 py-3 rounded-3 theme-card-6 ${styles.approvedSolarComponent}`}
    >
      <Row className="align-items-center justify-content-between">
        <Col xl={9}>
          <Row className="align-items-center">
            <Col className="col-auto">
              <MaterialIcon
                icon={getSolarProductIcon(product.category)}
                color="var(--color-component-icon)"
              />
            </Col>
            {category ===
            EViewSolarEstimationSolarProductCategory.WATER_HEATERS ? (
              <Col xl={4}>
                <Row>
                  <Col className="title-4 font-weight-500">{name}</Col>
                </Row>
                <Row>
                  <Col className="text-advance-description font-size-12">
                    Heater Panel: {product.heaterPanel}
                  </Col>
                </Row>
                <Row>
                  <Col className="text-advance-description font-size-12">
                    Tank Size : {product.liters}L
                  </Col>
                </Row>
                <Row>
                  <Col className="text-advance-description font-size-12">
                    Stand : {product.stand}
                  </Col>
                </Row>
              </Col>
            ) : (
              <Col xl={4}>
                <Row>
                  <Col className="title-4 font-weight-500">{name}</Col>
                </Row>
                <Row>
                  <Col className="text-advance-description font-size-12">
                    Operating Voltage: {voltage}
                  </Col>
                </Row>
                <Row>
                  <Col className="text-advance-description font-size-12">
                    Max Operating Voltage: {maxOperatingVoltage}
                  </Col>
                </Row>
              </Col>
            )}
            <Col className="text-color-5 font-weight-500 font-size-12">
              {currency}&nbsp;{formatWithCommas(Number(Helper.roundTo2(price)))}
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className="align-items-center gap-5">
            <Col xl={2} className="text-label font-size-24 font-weight-600">
              x{count}
            </Col>
            <Col className="text-label font-weight-600 text-end">
              {currency}&nbsp;
              {formatWithCommas(Number(Helper.roundTo2(count * price)))}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ApprovedSolarComponent;
